const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsMobile = { name: 'Mobile', pathName: null }
const breadcrumbsSorteio = { name: 'Sorteios', pathName: '/mobile/sorteios', action: 'sorteios' }

export default [
  {
    path: '/mobile',
    component: () => import('@/modules/mobile/views/pages/Mobile.vue'),
    children: [
      {
        path: 'configuracoes',
        title: 'Configurações Mobile',
        component: () => import('@/modules/mobile/configuracoes/views/pages/Configuracoes.vue'),
        meta: {
          title: 'Configurações Mobile',
          permission: 'mobile',
        },
        children: [
          {
            path: '',
            component: () => import('@/modules/mobile/configuracoes/views/pages/Banner.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Configurações mobile',
                  pathName: null,
                },
              ],
              permission: 'mobile',
              pagePermission: 'mobile/configuracoes',
            },
          },
        ],
      },
      {
        path: 'ofertas',
        title: 'Ofertas do aplicativo',
        component: () => import('@/modules/mobile/ofertas/views/pages/Ofertas.vue'),
        meta: {
          title: 'Ofertas do aplicativo',
          permission: 'mobile',
        },
        children: [
          {
            path: 'produtos',
            component: () => import('@/modules/mobile/ofertas/views/pages/Produtos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              permission: 'mobile',
              title: 'Ofertas do aplicativo',
              pagePermission: 'mobile/ofertas/produtos',
            },
            children: [
              {
                path: 'edicao',
                meta: {
                  pagePermission: 'mobile/ofertas/produtos/edicao',
                  title: 'Ofertas do aplicativo',
                },
              },
              {
                path: 'edicao-lojas-franquia',
                meta: {
                  pagePermission: 'mobile/ofertas/produtos/edicao-lojas-franquia',
                },
              },
            ],
          },
          {
            path: 'destaques',
            component: () => import('@/modules/mobile/ofertas/views/pages/Destaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              permission: 'mobile',
              pagePermission: 'mobile/ofertas/destaques',
              title: 'Ofertas em destaque',
            },
          },
          {
            path: 'destaques/editar/:type',
            component: () => import('@/modules/mobile/ofertas/views/pages/EditarDestaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              permission: 'mobile',
              pagePermission: 'mobile/ofertas/destaques',
              title: 'Ofertas em destaque',
            },
          },
        ],
      },
      {
        path: 'banners',
        name: 'banners-list',
        component: () => import('@/modules/mobile/banners/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Banners',
              pathName: null,
            },
          ],
          title: 'Banners',
          permission: 'mobile',
          pagePermission: 'mobile/banners',
        },
      },
      {
        path: 'banners/novo',
        name: 'banners-new',
        component: () => import('@/modules/mobile/banners/views/pages/Banner.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Banners',
              pathName: '/mobile/banners',
            },
            {
              name: 'Novo Banner',
              pathName: 'novo',
            },
          ],
          title: 'Banners',
          permission: 'mobile',
          pagePermission: 'mobile/banners',
        },
      },
      {
        path: 'banners/editar/:id',
        name: 'banners-edit',
        component: () => import('@/modules/mobile/banners/views/pages/Banner.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Banners',
              pathName: '/mobile/banners',
            },
            {
              name: 'Editar Banner',
              pathName: null,
            },
          ],
          title: 'Editar Banner',
          pagePermission: 'mobile/banners',
        },
      },
      {
        path: 'banners/resultados/:id',
        name: 'banners-result',
        component: () => import('@/modules/mobile/banners/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Banners',
              pathName: '/mobile/banners',
            },
            {
              name: 'Resultados do Banner',
              pathName: null,
            },
          ],
          title: 'Resultados do Banner',
          pagePermission: 'mobile/banners',
        },
      },
      {
        path: 'pontos',
        name: 'pontos',
        component: () => import('@/modules/mobile/pontos/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Pontos',
              pathName: null,
            },
          ],
          title: 'Pontos',
          permission: 'points',
          pagePermission: 'mobile/pontos',
        },
      },
      {
        path: 'pontos/novo',
        component: () => import('@/modules/mobile/pontos/views/pages/Pontos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Pontos',
              pathName: '/mobile/pontos',
            },
            {
              name: 'Novo vale-troca',
              pathName: 'novo',
            },
          ],
          title: 'Pontos',
          permission: 'points',
          pagePermission: 'mobile/pontos',
        },
      },
      {
        path: 'pontos/:id',
        alias: ['pontos/resultados/:id', 'pontos/editar/:id'],
        component: () => import('@/modules/mobile/pontos/views/pages/Pontos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Pontos',
              pathName: '/mobile/pontos',
            },
            {
              name: 'Editar vale-troca',
              pathName: null,
            },
          ],
          title: 'Pontos',
          permission: 'points',
          pagePermission: 'mobile/pontos',
        },
      },
      {
        path: 'pontos/bloqueios-de-saldos',
        component: () => import('@/modules/mobile/pontos/views/pages/PointsBalanceLock.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Pontos',
              pathName: '/mobile/pontos',
            },
            {
              name: 'Bloqueio de saldos',
              pathName: null,
            },
          ],
          title: 'Bloqueio de saldos de pontos',
          permission: 'points',
          pagePermission: 'mobile/pontos/bloqueios-de-saldos',
        },
      },
      {
        path: 'desempenho',
        alias: 'mobile/desempenho',
        component: () => import('@/modules/mobile/desempenho/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Desempenho',
              pathName: null,
            },
          ],
          title: 'Desempenho',
          permission: 'mobile',
          pagePermission: 'mobile/desempenho',
        },
      },
      {
        path: 'cashback',
        name: 'Cashback',
        component: () => import('@/modules/mobile/cashback/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Cashback',
              pathName: null,
              action: 'mobile/cashback',
            },
          ],
          title: 'Cashback',
          permission: 'cashback',
        },
        children: [
          {
            path: 'cashback',
            component: () => import('@/modules/mobile/cashback/views/pages/CashbackMetrics.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Cashback',
                  pathName: null,
                  action: 'mobile/cashback',
                },
              ],
              title: 'Cashback',
              permission: 'mobile',
              pagePermission: 'mobile/cashback/cashback',
            },
          },
          {
            path: 'controle-de-cpf',
            name: 'Controle de cpf',
            component: () => import('@/modules/mobile/pontos/views/components/index/voucher-cpf-block/VoucherCpfBlock.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Cashback',
                  pathName: null,
                  action: 'mobile/cashback',
                },
              ],
              title: 'Controle de CPFs',
              permission: 'mobile',
              pagePermission: 'mobile/cashback/controle-de-cpf',
            },
          },
          {
            path: 'bloqueios-de-saldos',
            component: () => import('@/modules/mobile/cashback/views/pages/CashbackBalanceLock.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Cashback',
                  pathName: null,
                  action: 'mobile/cashback',
                },
              ],
              title: 'Bloqueio de saldos',
              permission: 'mobile',
              pagePermission: 'mobile/cashback/bloqueios-de-saldos',
            },
          },
          {
            path: 'ajustes',
            component: () => import('@/modules/mobile/cashback/views/pages/CashbackAdjustments.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Cashback',
                  pathName: null,
                  action: 'mobile/cashback',
                },
              ],
              title: 'Ajustes de Cashback',
              permission: 'mobile',
              pagePermission: 'mobile/cashback/ajustes',
            },
          },
        ],
      },
      {
        path: 'bloquear-cpf',
        name: 'bloquear-cpf',
        component: () => import('@/modules/mobile/bloquear-cpf/views/BlockDocument.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Novo bloqueio',
              pathName: 'bloquear-cpf',
            },
          ],
          title: 'Novo bloqueio',
        },
      },
      {
        path: 'encartes',
        component: () => import('@/modules/mobile/encartes/views/pages/Encartes.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Encartes',
              pathName: null,
            },
          ],
          title: 'Encartes',
          pagePermission: 'mobile/encartes',
        },
      },
      {
        path: 'encartes/novo',
        component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
        props: { newCampaign: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Encartes',
              pathName: '/mobile/encartes',
            },
            {
              name: 'Novo encarte',
              pathName: null,
            },
          ],
          title: 'Encartes',
          pagePermission: 'mobile/encartes',
        },
      },
      {
        path: 'encartes/editar/:id',
        name: 'encartes-edit',
        component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
        props: { newCampaign: false },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Encartes',
              pathName: '/mobile/encartes',
            },
            {
              name: 'Editar encarte',
              pathName: null,
            },
          ],
          title: 'Encartes',
          pagePermission: 'mobile/encartes',
        },
      },
      {
        path: 'encartes/visualizar/:id',
        component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
        props: { newCampaign: false, readOnly: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Encartes',
              pathName: '/mobile/encartes',
            },
            {
              name: 'Visualizar encarte',
              pathName: null,
            },
          ],
          title: 'Encartes',
          pagePermission: 'mobile/encartes',
        },
      },
      {
        path: 'encartes/resultados/:id',
        name: 'encartes-resultados',
        component: () => import('@/modules/mobile/encartes/views/pages/ResultadosEncarte.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Encartes',
              pathName: '/mobile/encartes',
            },
            {
              name: 'Resultados do encarte',
              pathName: null,
            },
          ],
          title: 'Encartes',
          pagePermission: 'mobile/encartes',
        },
      },
      // {
      //   path: 'chatbot',
      //   title: 'Chatbot',
      //   component: () => import('@/modules/mobile/chatbot/views/pages/Chatbot.vue'),
      //   meta: {
      //     title: 'Chatbot',
      //     permission: 'chatbot',
      //   },
      //   children: [
      //     {
      //       path: '',
      //       component: () => import('@/modules/mobile/chatbot/views/pages/Avaliacoes.vue'),
      //       meta: {
      //         breadcrumbs: [
      //           breadcrumbsHome,
      //           breadcrumbsMobile,
      //           {
      //             name: 'Chatbot',
      //             pathName: '/mobile/chatbot',
      //           },
      //         ],
      //         permission: 'chatbot',
      //         pagePermission: 'mobile/chatbot',
      //       },
      //     },
      //   ],
      // },
      {
        path: 'sorteios',
        name: 'Sorteio',
        component: () => import('@/modules/mobile/sorteio/views/pages/ListRaffles.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Sorteios',
              pathName: null,
            },
          ],
          title: 'Sorteios',
          pagePermission: 'mobile/sorteio',
        },
      },
      {
        path: 'sorteios/novo',
        component: () => import('@/modules/mobile/sorteio/views/pages/EditRaffle.vue'),
        props: { newRaffle: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            breadcrumbsSorteio,
            {
              name: 'Novo Sorteio',
              pathName: null,
            },
          ],
          title: 'Novo Sorteio',
          pagePermission: 'mobile/sorteio',
        },
      },
      {
        path: 'sorteios/sorteador',
        name: 'Sorteador',
        component: () => import('@/modules/mobile/sorteio/views/pages/RaffleResult.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsMobile, breadcrumbsSorteio],
          title: 'Sorteador',
          pagePermission: 'mobile/sorteio',
        },
      },
      {
        path: 'sorteios/:id',
        component: () => import('@/modules/mobile/sorteio/views/pages/EditRaffle.vue'),
        props: { newRaffle: false },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            breadcrumbsSorteio,
            {
              name: 'Editar Sorteio',
              pathName: null,
            },
          ],
          name: 'Editar sorteio',
          title: 'Editar Sorteio',
          pagePermission: 'mobile/sorteio',
        },
      },
      {
        path: 'destaques',
        name: 'highlight-list',
        component: () => import('@/modules/mobile/destaques/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Destaques',
              pathName: null,
            },
          ],
          title: 'Destaques',
          pagePermission: 'mobile/destaques',
        },
      },
      {
        path: 'destaques/novo',
        name: 'highlight-new',
        component: () => import('@/modules/mobile/destaques/views/pages/Campaign.vue'),
        props: { newCampaign: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Destaques',
              pathName: '/mobile/destaques',
            },
            {
              name: 'Novo destaque',
              pathName: null,
            },
          ],
          title: 'Novo destaque',
          pagePermission: 'mobile/destaques',
        },
      },
      {
        path: 'destaques/editar/:id',
        name: 'highlight-edit',
        component: () => import('@/modules/mobile/destaques/views/pages/Campaign.vue'),
        props: { newHighlight: false },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Destaques',
              pathName: '/mobile/destaques',
            },
            {
              name: 'Editar destaque',
              pathName: null,
            },
          ],
          title: 'Editar destaque',
          pagePermission: 'mobile/destaques',
        },
      },
    ],
  },
]
